import type { FunctionComponent, PropsWithChildren } from 'react';
import Head from 'next/head';

interface CaireHeadProps extends PropsWithChildren {
  title?: string;
  description?: string;
}

const CaireHead: FunctionComponent<CaireHeadProps> = ({
  children,
  title,
  description,
}) => {
  const pageTitle = title
    ? `${title} — ${process.env.NEXT_PUBLIC_APP_TITLE}`
    : process.env.NEXT_PUBLIC_APP_TITLE;
  return (
    <Head>
      <meta key="head.charset" charSet="utf-8" />
      <title key="head.title">{pageTitle}</title>
      <meta
        key="head.description"
        name="description"
        content={description ?? ''}
      />
      <meta
        key="head.viewport"
        name="viewport"
        content="width=device-width, initial-scale=1"
      />

      <link
        key="head.favicon.256"
        rel="icon"
        href="/images/favicon/favicon.256.png"
        sizes="256x256"
      />
      <link
        key="head.favicon.64"
        rel="icon"
        href="/images/favicon/favicon.64.png"
        sizes="64x64"
      />
      <link
        key="head.favicon.32"
        rel="icon"
        href="/images/favicon/favicon.32.png"
        sizes="32x32"
      />
      <link key="head.favicon.default" rel="icon" href="/favicon.png" />

      {children}
    </Head>
  );
};

export default CaireHead;
